import { ShipmentStatusEnum } from '../types/shipment'

export const truckTypeOptions = {
  'Box truck': { colorScheme: 'gray', label: 'Box truck', value: 'Box truck' },
  Conestoga: { colorScheme: 'gray', label: 'Conestoga', value: 'Conestoga' },
  Deck: { colorScheme: 'gray', label: 'Deck', value: 'Deck' },
  'Double drop': { colorScheme: 'gray', label: 'Double drop', value: 'Double drop' },
  'Dry bulk': { colorScheme: 'gray', label: 'Dry bulk', value: 'Dry bulk' },
  Flatbed: { colorScheme: 'gray', label: 'Flatbed', value: 'Flatbed' },
  Lowboy: { colorScheme: 'gray', label: 'Lowboy', value: 'Lowboy' },
  Other: { colorScheme: 'gray', label: 'Other', value: 'Other' },
  'Power only': { colorScheme: 'gray', label: 'Power only', value: 'Power only' },
  RGN: { colorScheme: 'gray', label: 'RGN', value: 'RGN' },
  Reefer: { colorScheme: 'gray', label: 'Reefer', value: 'Reefer' },
  'Sprinter van': { colorScheme: 'gray', label: 'Sprinter van', value: 'Sprinter van' },
  'Step deck': { colorScheme: 'gray', label: 'Step deck', value: 'Step deck' },
  Tanker: { colorScheme: 'gray', label: 'Tanker', value: 'Tanker' },
  Van: { colorScheme: 'gray', label: 'Van', value: 'Van' }
}

export const getTruckType = (truckType: string | null) => {
  if (!truckType) return null

  const truckTypeOption = truckTypeOptions[truckType as keyof typeof truckTypeOptions]

  if (!truckTypeOption) return { colorScheme: 'gray', label: 'Confirm equipment', value: 'Other' }

  return truckTypeOption
}

export const mapColorSchemeToTailwindClass: Record<string, string> = {
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100',
  gray: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100',
  green: 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100',
  purple: 'bg-purple-100 text-purple-800 dark:bg-purple-800 dark:text-purple-100',
  red: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100'
}

export const shipmentStatusConfig: Record<string, { color: string }> = {
  [ShipmentStatusEnum.NeedsCarrier]: {
    color:
      'bg-yellow-100 text-yellow-800 dark:bg-[var(--color-custom-light-gray)]/15 dark:text-[var(--color-custom-light-gray)]'
  },
  [ShipmentStatusEnum.CarrierAssigned]: {
    color:
      'bg-blue-100 text-blue-800 dark:bg-[var(--color-custom-light-blue)]/10 dark:text-[var(--color-custom-light-blue)]'
  },
  [ShipmentStatusEnum.InTransit]: {
    color:
      'bg-purple-100 text-purple-800 dark:bg-[var(--color-custom-purple)]/15 dark:text-[var(--color-custom-purple)]'
  },
  [ShipmentStatusEnum.Delivered]: {
    color: 'bg-green-100 text-green-800 dark:bg-[var(--color-custom-green)]/20 dark:text-[var(--color-custom-green)]'
  },
  [ShipmentStatusEnum.Canceled]: {
    color: 'bg-red-100 text-red-800 dark:bg-[var(--color-custom-red)]/15 dark:text-[var(--color-custom-red)]'
  }
}

export const getShipmentStatusColor = (status: ShipmentStatusEnum | string): string => {
  return shipmentStatusConfig[status as ShipmentStatusEnum]?.color ?? 'bg-muted text-foreground'
}

const priorityColors = {
  P0: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  P1: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  P2: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  P3: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  P4: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  stretch: 'bg-muted text-foreground'
}

export const getPriorityColor = (priority: string): string => {
  return priorityColors[priority as keyof typeof priorityColors] ?? 'bg-muted text-foreground'
}
